(function($) {
    objectFitImages();
})( jQuery );